import {
  activeModelVrMenuOpenSelector,
  orderPermalinkSelector,
  saveModelsVR,
  updateModelsVr,
  useAppDispatch,
  useAppSelector,
  vrNeedsSaveSelector,
  vrIsSavingSelector,
} from '../../../store';

import cx from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUpRightFromSquare,
  faEye,
  faEyeSlash,
  faSpinner,
} from '@fortawesome/pro-regular-svg-icons';

import { apiBaseURL } from '../../../config';
import { LayoutButton } from './LayoutButton';
import './AdminMenu.scss';

export function AdminMenu({
  layouts,
  activeLayout,
  onSelectLayout,
  views,
  activeView,
  setActiveView,
  defaultView,
  setDefaultView,
  links,
  setHoveredLinkID,
  onDragLink,
  modelID,
}) {
  const dispatch = useAppDispatch();
  const order = useAppSelector(orderPermalinkSelector);
  const needsSave = useAppSelector(vrNeedsSaveSelector);
  const isSaving = useAppSelector(vrIsSavingSelector);
  const activeModelVrMenuOpen = useAppSelector(activeModelVrMenuOpenSelector);

  const isActiveView = (viewId) => {
    return activeView === viewId;
  };

  const linkIsPlaced = (viewID) => {
    return !!links[viewID];
  };

  const toggleVrMenuOpen = () => {
    dispatch(updateModelsVr({vrMenuOpen: !activeModelVrMenuOpen}));
  };

  return (
    <div id="vr-admin">
      {layouts.length > 1 && (
        <div id="vr-admin-layouts">
          <button
            className="layout-button"
            onClick={toggleVrMenuOpen}
            title={activeModelVrMenuOpen ? 'Load with Menu visible' : 'Load with Menu hidden'}
          >
            <FontAwesomeIcon icon={activeModelVrMenuOpen ? faEye : faEyeSlash} />
          </button>
          {layouts.map((name) => {
            return (
              <LayoutButton
                key={name}
                name={name}
                active={name === activeLayout}
                onSelectLayout={onSelectLayout}
              />
            );
          })}
        </div>
      )}
      <div id="vr-admin-title">
        <a
          href={`${apiBaseURL}/${order}/models/${modelID}`}
          title="Open in platform"
          target="_blank"
          rel="noreferrer"
        >
          {views.find((v) => v.id === activeView)?.title}
          <sup>
            <FontAwesomeIcon icon={faUpRightFromSquare} />
          </sup>
        </a>
      </div>
      <div id="vr-admin-main">
        { views.length > 1 && views.map((view) => {
          return (
            <div
              key={view.id}
              className="vr-admin-button"
              title={`${view.title} (${view.id})`}
            >
              <button
                className={cx({ placed: linkIsPlaced(view.id), active: isActiveView(view.id) })}
                // highlight this link on click
                onClick={() => linkIsPlaced(view.id) && setHoveredLinkID(view.id)}
                onDoubleClick={() => setActiveView(view.id) }
              >
                <img
                  src="/icons/link.png"
                  alt="link"
                  draggable={!linkIsPlaced(view.id) && !isActiveView(view.id)}
                  onDragEnd={() => onDragLink(view.id, view.title)}
                />
              </button>
              <p>{view.name}</p>
            </div>
          );
        })}
      </div>
      <div id="vr-admin-bottom">
        {defaultView !== activeView && activeLayout && (
          <button onClick={() => setDefaultView(activeView)}>Set as default view</button>
        )}
        {needsSave && (
          <button
            onClick={() => dispatch(saveModelsVR())}
            disabled={isSaving}
          >
            { isSaving ? (
              <>
                <FontAwesomeIcon
                  icon={faSpinner}
                  spin
                />
                Saving...
              </>
            ) : 'Save' }
          </button>
        )}
      </div>
    </div>
  );
}
